import { render, staticRenderFns } from "./GeneralMain.vue?vue&type=template&id=3abc512e"
import script from "./GeneralMain.vue?vue&type=script&lang=js"
export * from "./GeneralMain.vue?vue&type=script&lang=js"
import style0 from "./GeneralMain.vue?vue&type=style&index=0&id=3abc512e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports